import useAuth from './useAuth';

// TODO: later here could be more checks that user is not some particular type, or we will have some explicit check that user is super admin
const useIsSuperAdmin = () => {
  const auth = useAuth();

  return auth.isAuthenticated && !auth.user.event;
};

export default useIsSuperAdmin;
